import { v7PreSaleStatus } from 'app/views/plans/PlansData'
import { timeToPreSaleEnd } from 'app/views/timerUtils'

export default {
  data() {
    return {
      intervalId: null,
      timeRemaining: {
        days: 0,
        hours: 0,
        minutes: 0
      }
    }
  },

  async created() {
    this.initializeClock()
  },

  methods: {
    v7PreSaleActive() {
      return v7PreSaleStatus.preSaleActive
    },

    initializeClock() {
      this.timeRemaining = timeToPreSaleEnd()

      if (this.timeRemaining.days >= 0 && this.timeRemaining.hours >= 0 && this.timeRemaining.minutes >= 0) {
        this.intervalId = setInterval(() => {
          this.timeRemaining = timeToPreSaleEnd()

          if (this.timeRemaining.days <= 0 && this.timeRemaining.hours <= 0 && this.timeRemaining.minutes <= 0) {
            location.reload()
            clearInterval(this.intervalId)
          }
        }, 60000) // update every minute
      }
    },

    destroyed() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    }
  }
}
